import styled, { css } from "styled-components";
import { useContentMargins } from "@songtradr-one/components-frontend";
import {
  H3,
  semanticBdrWeak,
  spacingXlarge,
} from "@songtradr/component-library";

// TEXT

// STYLES
export const Section = styled.div<{ $slim?: boolean; $borderTop?: boolean }>(
  ({ $slim, $borderTop }) => {
    const [margin] = useContentMargins();
    return css`
      width: 100%;
      padding: ${$slim ? "3rem" : "5rem"} ${margin};
      border-top: ${$borderTop ? `1px solid ${semanticBdrWeak}` : "none"};
    `;
  },
);

export const SectionTitle = styled(H3)`
  margin: 0 0 ${spacingXlarge};
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
